<template>
  <v-container fluid>
    <TopHeader>
      <template v-slot:title>
        <!-- <div>
          <v-btn
            @click="$router.push({ name: 'Catalog' })"
            color="primary"
            small
            text
          >
            <v-icon left>mdi-keyboard-return</v-icon> Return to catalog
          </v-btn>
        </div> -->
        <span class="text-h5">
          Products /
          <span
            class="breadcrumb-link"
            @click="$router.push({ name: 'Catalog' })"
            >Catalog</span
          >
          / <span class="primary--text">New product</span>
          <span class="primary--text">{{ $route.params.product }}</span>
        </span>
      </template>
      <template v-slot:right>
        <span
          class="subtitle-1 grey--text font-weight-light d-flex"
          style="align-items: flex-end;"
        >
          <v-btn
            color="primary"
            outlined
            @click="submit"
            :loading="isLoading"
            :disabled="!hasChanged || isLoading"
          >
            <v-icon left>mdi-content-save-outline</v-icon> Create product
          </v-btn>
        </span>
      </template>
    </TopHeader>
    <v-row class="mt-5">
      <v-col cols="12">
        <v-form v-model="isFormValid" ref="form">
          <Product
            :rules="rules"
            v-model="product"
            :tab-index="tab"
            @onTabChange="t => (tab = t)"
            :isCreateRequest="true"
          />
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Product from "@/components/perfumist/product/Product"
import TopHeader from "@/components/base/TopHeader.vue"
import { ProductService } from "@/services"
import { cloneDeep } from "lodash"
import { PROPOSAL_STATUS } from "@/data"
import { required } from "@/utils/validator"
import moment from "moment"
export default {
  components: {
    Product,
    TopHeader
  },
  data() {
    return {
      tab: 0,
      isFormValid: false,
      isLoading: false,
      productEmpty: null,
      product: {
        brand_id: this.$store.state?.globalBrand?.id,
        name: "",
        bottle_size: null,
        product_type: "",
        gender: "",
        price: null,
        description: "",
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        priority: null,
        avg_rating: null,
        ratings_count: null,
        views_count: null,
        url: null,
        year: null,
        // currency: "eur",
        category: "body_fragrance",
        data: {
          product_families: {
            families: [],
            sub_families: []
          },
          product_notes: {
            top: [],
            base: [],
            middle: []
          },
          validated: true,
          validated_at: new Date(),
          launched_at: null,
          discontinued: 0,
          price: null,
          discontinued_at: null,
          variants: [],
          images: { main: null, bottle: null, package: null },
          locales: [
            {
              code: "en",
              name: "English",
              data: {
                name: "",
                description: ""
              }
            }
          ]
        }
      }
    }
  },
  computed: {
    rules() {
      const discontinuedAtRules =
        this.product.data.discontinued === 1 ? [required] : null

      if (this.$store.getters.isUserAdmin) {
        return {
          brand_input: [required],
          product_type: null,
          gender: null,
          price: null,
          year: null,
          category: null,
          product_families: {
            families: null,
            sub_families: null
          },
          product_notes: {
            top: null,
            base: null,
            middle: null
          },
          launched_at: null,
          discontinued_at: discontinuedAtRules,
          discontinued: null,
          images: { main: [required], bottle: null, package: null },
          locales: { en: { name: [required], description: null } }
        }
      }

      // normal user rules
      return {
        brand_input: [required],
        product_type: [required],
        gender: [required],
        price: null,
        year: [required],
        category: [required],
        product_families: {
          families: [required],
          sub_families: [required]
        },
        product_notes: {
          top: [required],
          base: [required],
          middle: [required]
        },
        launched_at: null,
        discontinued_at: discontinuedAtRules,
        discontinued: [required],
        images: { main: [required], bottle: null, package: null },
        locales: { en: { name: [required], description: [required] } }
      }
    },
    hasChanged() {
      if (this.product == null) return false
      return !this.lo.isEqual(this.productEmpty, this.product)
    }
  },
  created() {
    this.productEmpty = this.lo.cloneDeep(this.product)
  },
  methods: {
    createProductProposal() {
      return new Promise((resolve, reject) => {
        let brand_id
        if (Array.isArray(this.$store.state.globalBrand)) {
          brand_id = this.$store.state.globalBrand[0].brand_id
        } else {
          brand_id = this.$store.state.globalBrand.brand_id
        }
        ProductService.create(this, {
          data: this.product.data,
          data_approved: this.product.data,
          brand_id: brand_id
        })
          .then(r => {
            this.$store.commit("success", "Product create request sent !")
            resolve(r)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async createProduct() {
      this.isLoading = true
      const p = {
        ...cloneDeep(this.product),
        name: this.product.data.locales[0].data.name,
        description: this.product.data.locales[0].data.description,
        year: null,
        gender: this.product.data.gender,
        discontinued: this.product.data.discontinued,
        category: this.product.data.category,
        product_type: this.product.data.product_type
      }

      this.createProductProposal()
        .then(() => {
          this.$router.push({
            name: "Catalog"
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async submit() {
      this.$refs.form.validate()
      await this.$nextTick()
      if (!this.isFormValid) {
        this.$store.commit(
          "warning",
          `Some required fields were not filled.${"\n"} Please check all tabs (Description, Images, Attributes).`
        )
        return
      }
      if (
        confirm(
          `Are you sure you want to submit this product? ${
            this.$store.getters.isUserAdmin
              ? "(As an admin, this request is approved automatically)"
              : ""
          }`
        )
      ) {
        this.isLoading = true
        await this.createProductProposal()
        this.$store.commit("success", "Product create request sent !")
        this.$router.push({
          name: "Catalog"
          // params: { product: p.id }
        })
        this.isLoading = false
      }
      // Create Product
      // this.createProduct()
      // Create Product Data
      // Create Product CREATE_REQUEST
    }
  }
}
</script>

<style lang="scss">
.product-slider {
  .v-tabs-slider,
  .v-tab {
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
  }
  .v-tabs-slider-wrapper {
    z-index: 0 !important;
    height: 100% !important;
  }
  .v-tab--active {
    color: white !important;
  }
}
</style>
